import * as types from '../actions/auth-integrations-action-types';


// Access Authentication
const INITIAL_STATE_MANAGE_3P_INTEGRATION_SIGNUP = {
	isLoading: false,
	results: "",
	error: '',
};

export function access3pIntegrationSignupReducer(state = INITIAL_STATE_MANAGE_3P_INTEGRATION_SIGNUP, action) {

	switch (action.type) {
		case types.MANAGE_3P_INTEGRATION_SIGNUP_RESET:
			return INITIAL_STATE_MANAGE_3P_INTEGRATION_SIGNUP;
		case types.MANAGE_3P_INTEGRATION_SIGNUP_REQUEST:
			return { ...state, isLoading: true, results: {} };
		case types.MANAGE_3P_INTEGRATION_SIGNUP_SUCCESS:
			return { ...state, isLoading: false, results: action.payload };
		case types.MANAGE_3P_INTEGRATION_SIGNUP_FAILURE:
			return { ...state, isLoading: false, error: 'Error while trying to perform 3P integration authentication' };
		default:
			return state;
	}
}